export default __webpack_public_path__ + "static/media/nike1.8cc6d121.svg";